import type { ContourStyle } from '../../../types/ContourTypes';

const defaultContourConfig: ContourStyle = {
  renderOutline: true,
  outlineWidthAutoGenerated: 3,
  outlineWidth: 1,
  outlineWidthInactive: 1,
  outlineOpacity: 1,
  outlineOpacityInactive: 0.85,
  outlineDash: undefined,
  outlineDashInactive: undefined,
  outlineDashAutoGenerated: '5,3',
  activeSegmentOutlineWidthDelta: 0,
  renderFill: true,
  fillAlpha: 0.5,
  fillAlphaInactive: 0.3,
  fillAlphaAutoGenerated: 0.3,
};

function getDefaultContourStyle(): ContourStyle {
  return defaultContourConfig;
}

export default getDefaultContourStyle;
